import { createSelector } from 'reselect';
const sharedLinkPagesSelector = sharedLink => sharedLink.pages;
export default createSelector(sharedLinkPagesSelector, pages => {
  if (!pages) return [];
  return pages.map(({
    largeImageUrl
  }) => largeImageUrl);
});